import { scheduleCycleLabel, scheduleDescription, scheduleOptionLabel } from '../../utils/maintenanceSchedules';

export const MaintenanceScheduleLabel = ({ schedule, testPrefix, selected = false }) => {
  const description = scheduleDescription(schedule);
  const cycle = scheduleCycleLabel(schedule);
  return (
    <span className="block min-w-0 whitespace-normal text-left [overflow-wrap:anywhere]" title={scheduleOptionLabel(schedule)}>
      <span className={`block leading-snug ${description ? 'font-medium' : ''} ${selected ? 'line-clamp-2' : ''}`} data-testid={`${testPrefix}-description`}>{description || cycle}</span>
      {description && <span className="block mt-0.5 text-xs leading-snug text-slate-500" data-testid={`${testPrefix}-cycle`}>{cycle}</span>}
    </span>
  );
};